<template>
  <div>
    <b-modal v-model="showModal"
      title="Datos del registro"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <div><span><b>Código:</b> {{ record.code }}</span></div>
      <div><span><b>Curso:</b> {{ record.coursename }}</span></div>
      <div><span><b>Módulo:</b> {{ record.module }}</span></div>
      <div><span><b>Descripción:</b> <div v-html="record.description"></div></span></div>
      <div><span><b>Estado:</b> {{ record.status === 1 ? 'Activo' : 'Inactivo' }}</span></div>
      <hr v-if="record.url_video">
      <div v-if="record.url_video">
        <span><b>Video:</b></span>
      </div>
      <div v-if="record.url_video" class="container">
        <div class="row p-2 m-1" style="background-color: #efefef; border-radius: 10px;">
          <div class="col-12 text-center">
            <video-intro :src="record.url_video"></video-intro>
          </div>
        </div>
      </div>
      <br>
      <!-- {{ record.id }} -->
        <!-- Desea cambiar el estado del registo <strong>{{ codeRecord }}</strong>? -->
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
          <!-- <button @click="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i>Aceptar</button> -->
        </div>
    </b-modal>
  </div>
</template>

<script>
import VideoIntro from '../../MyCourse/partials/VideoIntro.vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal, VideoIntro},
  props: ['record', 'showModal'],
  data() {
    return {
      form: {},
      loading: false,
      dataRecord: [],
    }
  },
  methods:{
    close(bvModalEvent) {
      this.$emit('update:showModal', false)
      // this.$emit('getRecords');
      // bvModalEvent.preventDefault()
    },
    getRecord() {
      this.loading = true
      this.form = {
        id: this.id
      }
    },
  }
}

</script>